<template>
  <div>
    {{ $t('compCarbonFormsTravelsFormatsGes1p5Help.info-1') }}
    <a class="link" target="_blank" href="/api/travels_template/?ext=tsv">
      {{ $t('compCarbonFormsTravelsFormatsGes1p5Help.info-2') }}</a
    >
    {{ $t('compCarbonFormsTravelsFormatsGes1p5Help.info-3') }}
    <a class="link" target="_blank" href="/api/travels_template/?ext=csv">
      {{ $t('compCarbonFormsTravelsFormatsGes1p5Help.info-4') }}</a
    >.
    <br />
    <br />
    <ul style="list-style-type: square; margin-left: 25px">
      <li v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-5')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-6')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-7')"></li>
      <li>
        <span v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-8')" /><a
          class="link"
          @click="$emit('displayISO')"
        >
          {{ $t('compCarbonFormsTravelsFormatsGes1p5Help.link') }}</a
        >
        ;
      </li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-9')"></li>
      <li>
        <span
          v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-10')"
        /><a class="link" @click="$emit('displayISO')">
          {{ $t('compCarbonFormsTravelsFormatsGes1p5Help.link') }}</a
        >
        ;
      </li>
      <li>
        <span v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-11')" />
        {{ TRANSPORTATIONS.map((value) => $t(value)) }} ;
      </li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-12')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-13')"></li>
      <li>
        <span
          v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-14')"
        /><a class="link" @click="$emit('displayPurposeMapping')">
          {{ $t('compCarbonFormsTravelsFormatsGes1p5Help.link-purpose') }}</a
        >
        ;
      </li>
      <li>
        <span
          v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-15')"
        /><a class="link" @click="$emit('displayPositionMapping')">
          {{ $t('compCarbonFormsTravelsFormatsGes1p5Help.link-position') }}</a
        >
        ;
      </li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-16')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGes1p5Help.info-17')"></li>
    </ul>
  </div>
</template>

<script>
import Travel from '@/models/carbon/Travel.js'
import { useCoreStore } from '@/stores/core'

export default {
  name: 'Help',
  setup () {
    let coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    TRANSPORTATIONS: function () {
      return Travel.transportations
    }
  },
  methods: {
    toList (values) {
      return values.map((v) => '<li>' + v + '</li>').join('\n')
    }
  }
}
</script>
